import React from 'react';
import { useSortable } from '@dnd-kit/react/sortable';

import MemoryFilesGridItemPreview from '../../components/MemoryForm/FilesGridItemPreview';

import '@awesome.me/webawesome/dist/components/checkbox/checkbox.js';

import type { Asset } from '../../types/asset';

interface TimelineCreateMemoryAssetProps {
  asset: Asset;
  index: number;
  memoryId: string;
  selected?: boolean;
  splitMode?: boolean;
  disabled?: boolean;
  switchSelectedAsset?: Function;
  handleRemoveFile: Function;
};

const TimelineCreateMemoryAsset: React.FC<TimelineCreateMemoryAssetProps> = ({
  asset,
  index,
  memoryId,
  selected,
  splitMode,
  switchSelectedAsset,
  disabled,
  handleRemoveFile,
}) => {
  const { ref } = useSortable({
    id: `asset-${asset.id}`,
    index,
    group: `memory-${memoryId}`,
    type: 'item',
    accept: ['item'],
    disabled: splitMode || disabled,
  });

  return (
    <div key={asset.id} className="timeline-memory-asset memory-files-grid-item" ref={ref}>
      <MemoryFilesGridItemPreview file={asset} />
      {!disabled && (
        <>
          {splitMode ? (
            <wa-checkbox
              className="memory-files-grid-item-select"
              checked={selected}
              onChange={() => switchSelectedAsset && switchSelectedAsset(asset.id)}
            >
            </wa-checkbox>
          ) : (
            <wa-button
              appearance="accent"
              size="xs"
              className="memory-files-grid-item-remove"
              onClick={() => handleRemoveFile(asset.id)}
            >
              <wa-icon name="close" label="Remove"></wa-icon>
            </wa-button>
          )}
        </>
      )}
    </div>
  );
};

export default TimelineCreateMemoryAsset;
